import './DocumentSignModal.scss';
import React from 'react';
import { ModalBody, ModalHeader } from 'reactstrap';
import { DocumentSign } from '../DocumentSign/DocumentSign';
import Rodal from '../Rodal/Rodal';
import { useBodyScrollLock } from '../../hooks/useBodyScrollLock';

interface DocumentSignModalProps {
    isVisible: boolean;
    onClose: () => void;
    documentId: number;
    onSign: () => void;
}
export const DocumentSignModal = (props: DocumentSignModalProps) => {
    useBodyScrollLock();

    return (
        <Rodal
            className="document-sign-modal"
            visible={props.isVisible}
            onClose={props.onClose}>
            <ModalHeader>Sign Document</ModalHeader>
            <ModalBody>
                <DocumentSign
                    documentId={props.documentId}
                    onDocumentSign={props.onSign}
                />
                <div className="buttons-wrapper">
                    <button
                        className="btn btn-outline-secondary"
                        onClick={props.onClose}>
                        Cancel
                    </button>
                </div>
            </ModalBody>
        </Rodal>
    );
};
